import { useRouter as useBaseRouter } from 'vue-router'
import { useRoute } from '@/composables/route'

export enum RadiusUsersRouteName {
    Index = 'radius.index',
    Show = 'radius.server.show',
    UsersIndex = 'radius.server.users.index',
    UsersCreate = 'radius.server.users.create',
    UsersEdit = 'radius.server.users.edit',
    UsersUsage = 'radius.server.users.usage',
    AccountingIndex = 'radius.server.accounting.index',
    LoginHistoryIndex = 'radius.server.login-history.index',
    OnlineUsersIndex = 'radius.server.online-users.index',
}

export const radiusServerParamKey = 'radiusServerUuid'
export const radiusUserParamKey = 'radiusUserId'

export default {
    path: '/radius',
    name: RadiusUsersRouteName.Index,
    component: () => import('./views/Index.vue'),
    meta: {
        label: 'Radius',
        icon: 'fal fa-envelope-open-text fa-fw',
        auth: true,
    },
    children: [
        {
            path: `servers/:${radiusServerParamKey}`,
            name: RadiusUsersRouteName,
            component: () => import('./views/server/Show.vue'),
            meta: {
                label: 'Server',
                permission: 'manage-radius',
            },
            children: [
                {
                    path: 'users',
                    name: RadiusUsersRouteName.UsersIndex,
                    component: () => import('./views/server/users/Index.vue'),
                    meta: {
                        label: 'Users',
                        icon: 'fal fa-users fa-fw',
                        permission: 'manage-radius',
                    },
                    children: [
                        {
                            path: 'create',
                            name: RadiusUsersRouteName.UsersCreate,
                            component: () => import('./views/server/users/Index.vue'),
                            meta: {
                                label: 'Create User',
                                permission: 'manage-radius',
                            },
                        },
                        {
                            path: `:${radiusUserParamKey}/edit`,
                            name: RadiusUsersRouteName.UsersEdit,
                            component: () => import('./views/server/users/Index.vue'),
                            meta: {
                                label: 'Edit User',
                                permission: 'manage-radius',
                            },
                        },
                        {
                            path: `:${radiusUserParamKey}/usage`,
                            name: RadiusUsersRouteName.UsersUsage,
                            component: () => import('./views/server/users/Index.vue'),
                            meta: {
                                label: 'User Usage',
                                permission: 'manage-radius',
                            },
                        },
                    ],
                },
                {
                    path: 'accounting',
                    name: RadiusUsersRouteName.AccountingIndex,
                    component: () => import('./views/server/accounting/Index.vue'),
                    meta: {
                        label: 'Accounting',
                        icon: 'fal fa-book-user fa-fw',
                        permission: 'manage-radius',
                    },
                },
                {
                    path: 'login-history',
                    name: RadiusUsersRouteName.LoginHistoryIndex,
                    component: () => import('./views/server/login-history/Index.vue'),
                    meta: {
                        label: 'Login History',
                        icon: 'fal fa-sign-in-alt fa-fw',
                        permission: 'manage-radius',
                    },
                },
                {
                    path: 'online-users',
                    name: RadiusUsersRouteName.OnlineUsersIndex,
                    component: () => import('./views/server/online-users/Index.vue'),
                    meta: {
                        label: 'Online Users',
                        icon: 'fal fa-globe fa-fw',
                        permission: 'manage-radius',
                    },
                },
            ],
        },
    ],
}

export const useRadiusRouter = () => {
    const route = useRoute()
    const router = useBaseRouter()

    const goToRadiusUsers = (serverId?: string | null) =>
        router.push({
            name: RadiusUsersRouteName.UsersIndex,
            params: {
                ...route.params.value,
                serverId: serverId,
            },
            query: route.query.value,
        })

    const goToRadiusUsersCreate = (serverId?: string | null) =>
        router.push({
            name: RadiusUsersRouteName.UsersCreate,
            params: {
                ...route.params.value,
                serverId: serverId,
            },
            query: route.query.value,
        })

    const goToRadiusUserEdit = (userId: string, serverId?: string | null) =>
        router.push({
            name: RadiusUsersRouteName.UsersEdit,
            params: {
                ...route.params.value,
                serverId: serverId,
                userId: userId,
            },
            query: route.query.value,
        })

    const goToRadiusUserUsages = (userId: string, serverId?: string | null) =>
        router.push({
            name: RadiusUsersRouteName.UsersUsage,
            params: {
                ...route.params.value,
                serverId: serverId,
                userId: userId,
            },
            query: route.query.value,
        })

    return {
        goToRadiusUsers,
        goToRadiusUsersCreate,
        goToRadiusUserEdit,
        goToRadiusUserUsages,
    }
}
